import { Component, Input } from '@angular/core';
import { Card } from '../../../models/card';
import { ProvinceNamePipe } from '../pipes/province-name.pipe';
import { CountryNamePipe } from '../pipes/country-name.pipe';

@Component({
    selector: 'app-card-display',
    imports: [
        ProvinceNamePipe,
        CountryNamePipe
    ],
    templateUrl: './card-display.component.html',
    styleUrl: './card-display.component.scss'
})
export class CardDisplayComponent {

    @Input()
    public card: Card;

}
